import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN, Array } from '@blade/std-lib'
import { InfoMessage } from '@root/shared/ui-kit'

import { RelationFollowing } from './relation-following'

import type { FollowingsFilter } from '@root/features/user/user-connections'

type Props = {
  followingsFilter: FollowingsFilter
}

export const RelationFollowings = ({ followingsFilter }: Props) => {
  const [filterItemsState] = useAtom(followingsFilter.filterItemsStateAtom)
  const refreshFilter = useAction(followingsFilter.filterItemsStateAtom.refresh)

  return AsyncStateN.matchWaiting(filterItemsState, {
    Error: () => (
      <InfoContainer>
        <InfoMessage
          intent={'error'}
          variant="dt"
          onRetry={refreshFilter}
          withSeparator
        />
      </InfoContainer>
    ),
    Waiting: () => (
      <FilterResult>
        {Array.range(0, 5).map((x) => (
          <RelationFollowing.Skeleton key={x} withFollowings />
        ))}
      </FilterResult>
    ),
    Success: (followings) =>
      followings.length <= 0 ? (
        <InfoContainer>
          <InfoMessage intent={'empty'} variant="dt" />
        </InfoContainer>
      ) : (
        <FilterResult>
          {followings.map((following) => (
            <RelationFollowing key={following.delugeId} follower={following} />
          ))}
        </FilterResult>
      ),
  })
}

const FilterResult = styled.div`
  z-index: 0;
  display: grid;
  grid-auto-rows: max-content;
  gap: 12px;
`
const InfoContainer = styled.div`
  display: grid;
`
